module.exports = "<div ng-if=$ctrl.isActive ng-transclude></div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/gmc-tabs/components/gmc-tab/gmc-tab.component.html
// module id = 548
// module chunks = 31